import { render, staticRenderFns } from "./PublicChallengeDetails.vue?vue&type=template&id=4197b23c&scoped=true"
import script from "./PublicChallengeDetails.vue?vue&type=script&lang=js"
export * from "./PublicChallengeDetails.vue?vue&type=script&lang=js"
import style0 from "./PublicChallengeDetails.vue?vue&type=style&index=0&id=4197b23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197b23c",
  null
  
)

export default component.exports